import type {WithRequired} from '@deezer/next/services/types/utils';
import type {OfferType} from '@deezer/next/services/api/Starmania/requests/album/types';
import type {PeriodType} from '@components/DateRangePicker/types';

export type AgeList = {ageRange: string; label: string}[];

export type ArtistList = {id?: number; name: string}[];

export type ReleaseList = string[];

export type OfferList = {offerCode: OfferType; label: string}[];

export type PlaylistList = {id?: number; name: string}[];

export type EditorSegList = string[];

export type CountryList = {countryCode: string; label: string}[];

export enum TimeframePickerFrequency {
	DAILY = 'daily',
	MONTHLY = 'monthly',
	WEEKLY = 'weekly',
	PERIOD = 'period',
	CUSTOM = 'custom',
}

export interface Timeframe {
	frequency: TimeframePickerFrequency;
	dateFrom?: Date;
	dateTo?: Date;
	year?: number;
	period?: PeriodType;
}

export type WeekOption = {
	from: string;
	to: string;
};

export interface TimeframeOptions {
	[TimeframePickerFrequency.DAILY]?: {
		maxDate: string;
		minDate: string;
	};
	[TimeframePickerFrequency.MONTHLY]?: {
		year: number;
		months: string[];
	}[];
	weekly?: WeekOption[];
	[TimeframePickerFrequency.PERIOD]?: WeekOption[];
	[TimeframePickerFrequency.CUSTOM]?: {
		maxDate: string;
		minDate: string;
	};
}

export type DeliveryMonitoringTimeframeOptions = WithRequired<
	TimeframeOptions,
	'weekly'
>;
